import ServerDirections from '@/config/server-directions'
import { Profile } from '@/entities/Profile'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

var snakeCaseKeys = require('snakecase-keys')

export class ProfileRequests {
  get (id) {
    const route = ServerDirections.PROFILES_ID.replace('{id}', id)
    const method = 'get'
    function map (data) {
      return new Profile(data)
    }
    return requestService.makePromise(route, method, {}, map)
  }
  save (profile) {
    const route = ServerDirections.PROFILES
    const method = 'post'
    const body = snakeCaseKeys(profile)
    function map (data) {
      return data.id
    }
    return requestService.makePromise(route, method, { body }, map)
  }
}
